import React from "react";

// Brand wordmark — the "Fund" in "FightFund" is always red.
export function Brand({ className = "" }) {
  return (
    <span className={className}>
      Fight<span className="text-ff-red">Fund</span>
    </span>
  );
}

export default Brand;
